import { AsyncStoreItem } from '@lib';
import { PostCheckinConfirmResponse } from 'src/sdk_checkin';

/**
 * CheckinAcceptanceResult model
 */
export interface CheckinAcceptanceResultModel {
  checkinAcceptanceResult: PostCheckinConfirmResponse | null;
}

/**
 * PostCheckinConfirmResponse model details
 */
export interface CheckinAcceptanceResultStateDetails extends AsyncStoreItem {}

/**
 * CheckinAcceptanceResult store state
 */
export interface CheckinAcceptanceResultState
  extends CheckinAcceptanceResultStateDetails,
    CheckinAcceptanceResultModel {}

/**
 * Name of the CheckinAcceptanceResult Store
 */
export const CHECKIN_ACCEPTANCE_RESULT_STORE_NAME = 'checkinAcceptanceResult';

/**
 * CheckinAcceptanceResult Store Interface
 */
export interface CheckinAcceptanceResultStore {
  /** CheckinAcceptanceResult state */
  [CHECKIN_ACCEPTANCE_RESULT_STORE_NAME]: CheckinAcceptanceResultState;
}
